import { base64UrlToBuffer, bufferToBase64Url } from 'theSource/utils';
import { RegistrationDatatDto, RegistrationOptionsResponseDto } from '../types';

export const mapToCredentialCreationOptions = (
  data: RegistrationOptionsResponseDto
): CredentialCreationOptions => ({
  publicKey: {
    ...data,
    challenge: base64UrlToBuffer(data.challenge),
    user: {
      ...data.user,
      id: base64UrlToBuffer(data.user.id),
    },
  },
});

export const mapToRegistrationData = (
  credential: PublicKeyCredential
): RegistrationDatatDto => {
  const attestationResponse =
    credential.response as AuthenticatorAttestationResponse;

  const registrationData: RegistrationDatatDto = {
    type: credential.type,
    id: credential.id,
    rawId: bufferToBase64Url(credential.rawId),
    response: {
      attestationObject: bufferToBase64Url(
        attestationResponse.attestationObject
      ),
      clientDataJSON: bufferToBase64Url(attestationResponse.clientDataJSON),
    },
  };

  return registrationData;
};
